var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAscIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    viewBox: "0 0 4 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86078 1.02548L0.195927 3.69245C0.133811 3.75461 0.0845371 3.82842 0.0509198 3.90964C0.0173026 3.99086 -2.37007e-07 4.07792 -2.33164e-07 4.16583C-2.25403e-07 4.34339 0.0704771 4.51367 0.195927 4.63922C0.321378 4.76477 0.491525 4.8353 0.668938 4.8353C0.846352 4.8353 1.0165 4.76477 1.14195 4.63922L2.66758 3.10571L2.66758 8.83326C2.66758 9.01009 2.73777 9.17968 2.8627 9.30472C2.98764 9.42975 3.1571 9.5 3.33379 9.5C3.51048 9.5 3.67993 9.42975 3.80487 9.30472C3.92981 9.17968 4 9.01009 4 8.83326L4 1.49886C3.99934 1.36723 3.95977 1.23874 3.88626 1.12958C3.81276 1.02042 3.70861 0.935481 3.58695 0.885462C3.46562 0.834403 3.33191 0.820453 3.20267 0.845372C3.07343 0.870291 2.95446 0.932963 2.86078 1.02548Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscIcon);
export default __webpack_public_path__ + "static/media/sort-asc-icon.b4b9c6a471b4ea8feaac68fe202463de.svg";
export { ForwardRef as ReactComponent };